/* CLD cart drawer: gift colour change, discount code and delivery date.
   The theme replaces the whole drawer after every cart change, so everything here
   listens on document and re-reads the drawer each time. */
(function () {
  if (window.__cldCart) return;
  window.__cldCart = true;

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function post(path, body) {
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        return j;
      });
    });
  }
  function render(data) {
    if (window.EOLUX && window.EOLUX.Cart && data && data.sections) {
      window.EOLUX.Cart.render(data.sections, data);
      eta();
      return true;
    }
    return false;
  }
  /* Redraw the drawer from the current cart (no change), keeping it open. */
  function refresh() {
    return post('cart/update.js', { sections: ['cart-drawer'] }).then(function (data) {
      if (!render(data)) location.reload();
    });
  }

  /* Delivery date: working days from today. */
  function workday(d, sat) { var w = d.getDay(); return w !== 0 && (sat || w !== 6); }
  function addDays(from, n, sat) {
    var d = new Date(from);
    while (n > 0) { d.setDate(d.getDate() + 1); if (workday(d, sat)) n--; }
    return d;
  }
  function label(d) {
    var days = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    var months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()];
  }
  function eta() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cld-c-eta]'), function (el) {
      var sat = el.getAttribute('data-sat') === 'true';
      var ship = addDays(new Date(), +el.getAttribute('data-h') || 0, false);
      if (!workday(ship, false)) ship = addDays(ship, 1, false);
      var d1 = addDays(ship, +el.getAttribute('data-min') || 1, sat);
      var d2 = addDays(ship, +el.getAttribute('data-max') || 2, sat);
      var out = el.querySelector('[data-cld-c-eta-text]');
      if (out) out.innerHTML = (el.getAttribute('data-text') || '')
        .replace('[d1]', '<strong>' + label(d1) + '</strong>')
        .replace('[d2]', '<strong>' + label(d2) + '</strong>');
      el.hidden = false;
    });
  }

  /* Gift colour change (15 Oct 2026). The old brush is removed FIRST and the new colour added
     after, both read from a fresh cart: Shopify's automatic gift discount re-keys the cart
     lines whenever the cart changes, so a line key read from the drawer can be stale.
     The listener runs in the capture phase and stops the click, so the drawer stays open. */
  var giftBusy = false;
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-cld-gift-variant]') : null;
    if (!t) return;
    var line = t.closest('[data-line-key]');
    if (!line) return;
    e.preventDefault();
    e.stopPropagation();
    if (giftBusy || t.getAttribute('aria-pressed') === 'true' || t.disabled) return;
    giftBusy = true;
    line.style.opacity = '0.5';
    var key = line.getAttribute('data-line-key');
    var newId = +t.getAttribute('data-cld-gift-variant');
    var colours = Array.prototype.map.call(line.querySelectorAll('[data-cld-gift-variant]'), function (b) {
      return +b.getAttribute('data-cld-gift-variant');
    });
    fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        /* The brush line: the drawer's key if still valid, otherwise any line of the brush. */
        var old = items.filter(function (i) { return i.key === key; })[0] ||
          items.filter(function (i) { return colours.indexOf(i.variant_id) > -1; })[0];
        if (old && old.variant_id === newId) return null;
        return (old ? post('cart/change.js', { id: old.key, quantity: 0 }) : Promise.resolve())
          .then(function () { return post('cart/add.js', { items: [{ id: newId, quantity: 1 }] }); });
      })
      .catch(function () {})
      .then(function () { return refresh(); })
      .catch(function () { location.reload(); })
      .then(function () { giftBusy = false; });
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-cld-code-form]') : null;
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input');
    var code = (input.value || '').trim();
    if (!code) return;
    var bad = form.getAttribute('data-error') || '';
    form.setAttribute('aria-busy', 'true');
    post('cart/update.js', { discount: code, sections: ['cart-drawer'] }).then(function (data) {
      var ok = (data.discount_codes || []).some(function (c) {
        return c.applicable && String(c.code).toLowerCase() === code.toLowerCase();
      });
      render(data);
      if (!ok) {
        var d = document.querySelector('[data-cld-code]');
        var msg = document.querySelector('[data-cld-code-msg]');
        if (d) d.open = true;
        if (msg) { msg.textContent = bad; msg.hidden = false; }
      }
    }).catch(function () {
      form.removeAttribute('aria-busy');
    });
  });

  document.addEventListener('submit', function () { setTimeout(eta, 1200); setTimeout(eta, 3000); }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-quantity-change],[data-drawer-open],[data-add-to-cart]')) {
      setTimeout(eta, 1200); setTimeout(eta, 3000);
    }
  }, true);
  if (window.MutationObserver) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < list[i].addedNodes.length; j++) {
          var n = list[i].addedNodes[j];
          if (n.nodeType === 1 && n.matches && n.matches('[data-cart-drawer]')) { eta(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  eta();
})();
